import { render } from "./CometChatSenderVideoMessageBubble.vue?vue&type=template&id=64796d65&scoped=true"
import script from "./CometChatSenderVideoMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatSenderVideoMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatSenderVideoMessageBubble.vue?vue&type=style&index=0&id=64796d65&scoped=true&lang=css"
import "./CometChatSenderVideoMessageBubble.vue?vue&type=style&index=1&id=64796d65&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64796d65"]])

export default __exports__